import React from "react";
import toast from "react-hot-toast";
import { downloadDocument } from "../services/merchant";

const DocumentModal = ({ prospect, setShowDocument }) => {
  const retrieveKyc = async (file) => {
    try {
      const blobData = await downloadDocument(file.id);
      // Get the content type from the response headers
      const contentType = blobData.type;
      // Create a blob from the response data
      const blob = new Blob([blobData], { type: contentType });
      // Create a URL for the blob
      const url = window.URL.createObjectURL(blob);
      // Create a temporary <a> element
      const link = document.createElement("a");
      link.href = url;
      // Set the filename
      link.download = file?.fileName;
      // Simulate a click on the link to initiate the download
      link.click();
      // Cleanup
      window.URL.revokeObjectURL(url);
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
      }
    }
  };
  return (
    <div className="fixed inset-0 z-50 overflow-auto bg-black bg-opacity-50 flex justify-center items-center">
      <div className="modal-content flex flex-col justify-center h-fit w-[700px] bg-white p-6 rounded shadow-lg relative">
        <button
          className="close absolute top-3 right-2 py-1 cursor-pointer px-4 text-orange-400 border border-orange-400 rounded-md"
          onClick={() => setShowDocument(false)}
        >
          x
        </button>
        <div>
          <h1 className="text-lg font-bold text-center text-navy-blue">
            Prospect Details
          </h1>
          {prospect.terminalId && (
            <div className="mb-5">
              <h1 className="text-base font-bold text-navy-blue">
                Terminal ID
              </h1>
              <p>{prospect.terminalId}</p>
            </div>
          )}
          {prospect.merchantId && (
            <div className="mb-5">
              <h1 className="text-base font-bold text-navy-blue">
                Merchant ID
              </h1>
              <p>{prospect.merchantId}</p>
            </div>
          )}
          {prospect.comment && (
            <div className="mb-5">
              <h1 className="text-base font-bold text-navy-blue">Comment</h1>
              <p>{prospect.comment}</p>
            </div>
          )}
          <h1 className="text-base font-bold text-navy-blue">View Documents</h1>
          {prospect.documents.map((p) => (
            <div key={p.id} className="flex items-center justify-between m-5">
              <p>{p.fileName}</p>
              <div className="text-center">
                <p>File Type</p>
                <p>{p.key}</p>
              </div>
              <button
                className="bg-primary w-[200px] h-[50px] rounded-md text-white"
                onClick={() => retrieveKyc(p)}
              >
                Download
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DocumentModal;
